(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[466],{

/***/ 9703:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/article/[slug]",
      function () {
        return __webpack_require__(6333);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(260);
/* harmony import */ var components_Blocks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4512);
/* harmony import */ var components_ArticlesRelated__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1222);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5641);
/* harmony import */ var components_Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1382);
/* harmony import */ var _ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3176);
/* harmony import */ var _ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _helpers_formatDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1588);











function ArticleTemplate(param) {
    var data = param.data, className = param.className, classNameArticles = param.classNameArticles;
    var ref, ref1;
    var state = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_3__/* .GlobalStateContext */ .Pn);
    var flashMessageCleared = state.header.flashMessageCleared;
    if (!(data === null || data === void 0 ? void 0 : data.postBy)) return null;
    var _postBy = data.postBy, id = _postBy.id, title = _postBy.title, date = _postBy.date, acfPostSettings = _postBy.acfPostSettings, acfBlocks = _postBy.acfBlocks;
    var globalEventTag = acfPostSettings.globalEventTag, globalBrandTag = acfPostSettings.globalBrandTag, globalCampaignTag = acfPostSettings.globalCampaignTag, // globalCategoriesTag,
    globalPhotographerTag = acfPostSettings.globalPhotographerTag, globalPublicationTag = acfPostSettings.globalPublicationTag, globalStylistTag = acfPostSettings.globalStylistTag;
    var setSidebarItems = [
        {
            label: "Event",
            data: globalEventTag
        },
        {
            label: "Brand",
            data: globalBrandTag
        },
        {
            label: "Campaign",
            data: globalCampaignTag
        },
        // NOTE: If you add this make sure to filter out 'Uncategorized'
        //   {
        //   label: 'Cateogory',
        // data: globalCategoriesTag,
        //   },
        {
            label: "Photographer",
            data: globalPhotographerTag
        },
        {
            label: "Publication",
            data: globalPublicationTag
        },
        {
            label: "Stylist",
            data: globalStylistTag
        }, 
    ];
    var setDate = (0,_helpers_formatDate__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new Date(date));
    var models = acfPostSettings === null || acfPostSettings === void 0 ? void 0 : acfPostSettings.relatedModels;
    var relatedPosts = models === null || models === void 0 ? void 0 : (ref = models[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.relatedPosts) === null || ref1 === void 0 ? void 0 : ref1.filter(function(f) {
        return f.id !== id;
    });
    var setSidebarItem = function(label, data) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().tag),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().label),
                    dangerouslySetInnerHTML: {
                        __html: label
                    }
                }),
                data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().names),
                    children: data.map(function(param) {
                        var name = param.name;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().name),
                            dangerouslySetInnerHTML: {
                                __html: name
                            }
                        }, name);
                    })
                })
            ]
        }, label);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().container), className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().content),
                        children: acfBlocks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Blocks__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            postType: "Post",
                            children: acfBlocks
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().sidebar),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().sidebarContent),
                            children: [
                                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Title__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    title: title.substr(0, title.indexOf("|")) || title,
                                    subtitle: title.split("|").length === 2 ? null : title.split("|")[1],
                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().title)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().tags),
                                    children: [
                                        (models === null || models === void 0 ? void 0 : models.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().tag),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().label),
                                                    dangerouslySetInnerHTML: {
                                                        __html: "Models"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().names),
                                                    children: models.map(function(param) {
                                                        var slug = param.slug, title = param.title;
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            type: "Model",
                                                            href: slug,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: title
                                                                },
                                                                className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().name)
                                                            })
                                                        }, slug);
                                                    })
                                                })
                                            ]
                                        }),
                                        setSidebarItems === null || setSidebarItems === void 0 ? void 0 : setSidebarItems.map(function(item) {
                                            if (!item || item.data.length < 1) return null;
                                            return setSidebarItem(item.label, item.data);
                                        })
                                    ]
                                }),
                                setDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_ArticleTemplate_module_css__WEBPACK_IMPORTED_MODULE_9___default().date),
                                    children: setDate
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ArticlesRelated__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                wrapperClassName: classNameArticles,
                articles: relatedPosts
            })
        ]
    });
}
ArticleTemplate.propTypes = {
    data: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    classNameArticles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string)
};
ArticleTemplate.defaultProps = {
    data: {},
    className: "",
    classNameArticles: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleTemplate);


/***/ }),

/***/ 1222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5641);
/* harmony import */ var components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2657);
/* harmony import */ var _ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9305);
/* harmony import */ var _ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4__);






function ArticlesRelated(param) {
    var articles = param.articles, className = param.className, wrapperClassName = param.wrapperClassName;
    if (articles === null || articles.length < 1) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().container), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().wrapper), wrapperClassName),
            children: articles.filter(function(f) {
                return f.acfPost.featuredImage !== null;
            }).map(function(param) {
                var slug = param.slug, title = param.title, acfPost = param.acfPost, acfPostSettings = param.acfPostSettings;
                var ref, ref1, ref2;
                var setRelatedModels = acfPostSettings === null || acfPostSettings === void 0 ? void 0 : (ref = acfPostSettings.relatedModels) === null || ref === void 0 ? void 0 : ref.map(function(rm) {
                    return rm.title;
                }).join(", ").replace(/,(?!.*,)/gim, " &");
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: slug,
                    type: "Article",
                    className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().project),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().imgWrap),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                images: [
                                    {
                                        url: acfPost === null || acfPost === void 0 ? void 0 : (ref1 = acfPost.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl,
                                        params: "w_510,f_auto"
                                    },
                                    {
                                        url: acfPost === null || acfPost === void 0 ? void 0 : (ref2 = acfPost.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.mediaItemUrl,
                                        params: "w_445,f_auto"
                                    }, 
                                ],
                                className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().img)
                            })
                        }),
                        setRelatedModels && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().title),
                            dangerouslySetInnerHTML: {
                                __html: setRelatedModels
                            }
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: (_ArticlesRelated_module_css__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                            dangerouslySetInnerHTML: {
                                __html: title.substr(0, title.lastIndexOf("|")) || title
                            }
                        })
                    ]
                }, slug);
            })
        })
    });
}
ArticlesRelated.propTypes = {
    articles: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().array),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    wrapperClassName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
ArticlesRelated.defaultProps = {
    articles: [],
    className: "",
    wrapperClassName: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticlesRelated);


/***/ }),

/***/ 2583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Loading_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9152);
/* harmony import */ var _Loading_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Loading_module_css__WEBPACK_IMPORTED_MODULE_2__);




function Loading(param) {
    var initialColours = param.initialColours, hideLinks = param.hideLinks, className = param.className, children = param.children;
    var initialPageColour = initialColours.initialPageColour, initialUiColour = initialColours.initialUiColour;
    var setInitialPageColour = initialPageColour ? initialPageColour : "#fff";
    var setInitialUiColour = initialUiColour ? initialUiColour : "#000";
    // const setInitialTextColour = initialTextColour ? initialTextColour : '#000'
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: "body { background-color: ".concat(initialPageColour, " }\n            #header *,\n            #header-title * {\n              color: ").concat(hideLinks ? initialPageColour : initialUiColour, "!important\n            }\n            #header *::before,\n            #header *::after,\n            #header-title-line { \n              background-color: ").concat(hideLinks ? initialPageColour : initialUiColour, "!important\n            }")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Loading_module_css__WEBPACK_IMPORTED_MODULE_2___default().container), (classnames__WEBPACK_IMPORTED_MODULE_1___default())),
                style: {
                    backgroundColor: setInitialPageColour
                },
                children: children
            })
        ]
    });
}
Loading.propTypes = {
    initialColours: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
    hideLinks: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
};
Loading.defaultProps = {
    initialColours: {},
    hideLinks: false,
    className: "",
    children: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 1382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8735);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Title_module_css__WEBPACK_IMPORTED_MODULE_2__);





function Title(param) {
    var title = param.title, subtitle = param.subtitle, swapColour = param.swapColour, lightUi = param.lightUi, borderTitle = param.borderTitle, lightSubtitle = param.lightSubtitle, className = param.className, shrinkSubtitleLength = param.shrinkSubtitleLength;
    if (!title) return null;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().container), className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().swapColour), swapColour), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().lightUi), lightUi), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().borderTitle), borderTitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().lightSubtitle), lightSubtitle), _obj)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().subtitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().subtitleLong), shrinkSubtitleLength && subtitle.length > shrinkSubtitleLength)),
                dangerouslySetInnerHTML: {
                    __html: subtitle
                }
            })
        ]
    });
}
Title.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    swapColour: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    lightUi: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    borderTitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    lightSubtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    shrinkSubtitleLength: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
};
Title.defaultProps = {
    title: "",
    subtitle: "",
    swapColour: false,
    lightUi: false,
    borderTitle: false,
    lightSubtitle: false,
    className: "",
    shrinkSubtitleLength: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 1588:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * @param {Date} date
 * @param {string} locale
 * @param {} options
 *
 * @return {string}
 */ var formatDate = function(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        dateStyle: "medium"
    };
    // Currently, we only use the GB format, but maybe we should use something better for America? ;-)
    return date.toLocaleDateString(locale, options);
};
/* harmony default export */ __webpack_exports__["Z"] = (formatDate);


/***/ }),

/***/ 6333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2583);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3825);
/* harmony import */ var components_WordpressSEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1610);
/* harmony import */ var components_ArticleTemplate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8772);







function Article(param) {
    var post = param.post, site = param.site, slug = param.slug, globalSettings = param.globalSettings;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    if (router.fallback || !post) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    // todo: if no 'post' set by this point we should show the 404 instead of Loading
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WordpressSEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                url: "/".concat(site, "/article/").concat(slug),
                seo: post.seo,
                title: post.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ArticleTemplate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                data: {
                    postBy: post
                }
            })
        ]
    });
}
Article.propTypes = {
    site: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    post: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    globalSettings: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object)
};
Article.defaultProps = {
    site: "",
    slug: "",
    post: null,
    globalSettings: {}
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Article);


/***/ }),

/***/ 3176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ArticleTemplate_spacing--xxxs__hgHVr","spacing--xxs":"ArticleTemplate_spacing--xxs__zelcf","spacing--xs":"ArticleTemplate_spacing--xs__HldPz","spacing--sm":"ArticleTemplate_spacing--sm__hKOUH","spacing--md":"ArticleTemplate_spacing--md__JfD_P","spacing--lg":"ArticleTemplate_spacing--lg__Y6xV6","spacing--xl":"ArticleTemplate_spacing--xl__jIkdc","spacing--xxl":"ArticleTemplate_spacing--xxl__GFAvL","spacing--xxxl":"ArticleTemplate_spacing--xxxl___Hy9_","container":"ArticleTemplate_container__Q1iYP","wrapper":"ArticleTemplate_wrapper__LJjdZ","sidebar":"ArticleTemplate_sidebar__40vNK","sidebarContent":"ArticleTemplate_sidebarContent__GVndq","title":"ArticleTemplate_title__nUACh","model":"ArticleTemplate_model__ukw_f","date":"ArticleTemplate_date__Wi_TE","tags":"ArticleTemplate_tags__u_RYl","tag":"ArticleTemplate_tag__sBo4f","label":"ArticleTemplate_label__oqQgK","name":"ArticleTemplate_name__oD7X_","names":"ArticleTemplate_names__UM_YS","fadeInItems":"ArticleTemplate_fadeInItems__MHg7t"};

/***/ }),

/***/ 9305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ArticlesRelated_spacing--xxxs__HwmnX","spacing--xxs":"ArticlesRelated_spacing--xxs___LKEs","spacing--xs":"ArticlesRelated_spacing--xs__5lJr5","spacing--sm":"ArticlesRelated_spacing--sm__bOnZw","spacing--md":"ArticlesRelated_spacing--md__H8nvn","spacing--lg":"ArticlesRelated_spacing--lg__NbATD","spacing--xl":"ArticlesRelated_spacing--xl__paO_V","spacing--xxl":"ArticlesRelated_spacing--xxl__mFWiY","spacing--xxxl":"ArticlesRelated_spacing--xxxl__ddWi4","container":"ArticlesRelated_container__TKTXC","wrapper":"ArticlesRelated_wrapper__o2xSe","project":"ArticlesRelated_project__4ZyZ5","imgWrap":"ArticlesRelated_imgWrap__DBe88","img":"ArticlesRelated_img__hlfxd","title":"ArticlesRelated_title__OLP1_","subtitle":"ArticlesRelated_subtitle__e4AxV","fadeInItems":"ArticlesRelated_fadeInItems__Oveg4"};

/***/ }),

/***/ 9152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Loading_spacing--xxxs__mrBZx","spacing--xxs":"Loading_spacing--xxs__gJPeb","spacing--xs":"Loading_spacing--xs__f8_dP","spacing--sm":"Loading_spacing--sm__BQT8f","spacing--md":"Loading_spacing--md__wjnkH","spacing--lg":"Loading_spacing--lg__vQy0F","spacing--xl":"Loading_spacing--xl__4069e","spacing--xxl":"Loading_spacing--xxl__MMJcu","spacing--xxxl":"Loading_spacing--xxxl__uHHvb","container":"Loading_container__gSMkV","fadeInItems":"Loading_fadeInItems__IBCzh"};

/***/ }),

/***/ 8735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Title_spacing--xxxs__sEhJq","spacing--xxs":"Title_spacing--xxs__DgJXk","spacing--xs":"Title_spacing--xs__DA8px","spacing--sm":"Title_spacing--sm__AvCBI","spacing--md":"Title_spacing--md__n1H3y","spacing--lg":"Title_spacing--lg___qrsK","spacing--xl":"Title_spacing--xl__7hIyQ","spacing--xxl":"Title_spacing--xxl__Eoec_","spacing--xxxl":"Title_spacing--xxxl__0Xl1t","container":"Title_container__5MuPN","swapColour":"Title_swapColour__Csfih","subtitle":"Title_subtitle__t4Jhl","lightUi":"Title_lightUi__owagC","borderTitle":"Title_borderTitle__opYdU","subtitleLong":"Title_subtitleLong__7K7dp","lightSubtitle":"Title_lightSubtitle__iCTJ6","fadeInItems":"Title_fadeInItems___Zi_4"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,216,66,529,895,774,888,179], function() { return __webpack_exec__(9703); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);